/*!

=========================================================
* Vue Argon Design System - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { BootstrapVue, IconsPlugin, BIconBlank } from 'bootstrap-vue'
import { mergeData } from 'vue-functional-data-merge'
import ApiService from '@/services/api.service';
import globalComponents from "./plugins/globalComponents";
import globalDirectives from "./plugins/globalDirectives";
import VueLazyload from "vue-lazyload";

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/styles/theme.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

// Icônes Bootstrap Icons absentes de la version embarquée (>= 1.8.0)
// On extrait BVIconBase depuis BIconBlank pour recréer des icônes compatibles
let BVIconBase = null
const blankOpts = BIconBlank.options || BIconBlank.sealedOptions
try {
  blankOpts.render((comp) => { BVIconBase = comp }, { data: {}, props: {} })
} catch (e) { /* BVIconBase capturé avant l'erreur */ }

if (BVIconBase) {
  Vue.component('BIconCarFront', {
    functional: true,
    props: (BVIconBase.options || BVIconBase.sealedOptions).props,
    render (h, { data, props }) {
      return h(BVIconBase, mergeData(data, {
        staticClass: 'bi-car-front',
        props: {
          ...props,
          content: '<path d="M4 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm10 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM6 8a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2H6ZM4.862 4.276 3.906 6.19a.51.51 0 0 0 .497.731c.91-.073 2.35-.17 3.597-.17 1.247 0 2.688.097 3.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 10.691 4H5.309a.5.5 0 0 0-.447.276Z"/><path d="M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679c.033.161.049.325.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.807.807 0 0 0 .381-.404l.792-1.848ZM4.82 3a1.5 1.5 0 0 0-1.379.91l-.792 1.847a1.8 1.8 0 0 1-.853.904.807.807 0 0 0-.43.564L1.03 8.904a1.5 1.5 0 0 0-.03.294v.413c0 .796.62 1.448 1.408 1.484 1.555.07 3.786.155 5.592.155 1.806 0 4.037-.084 5.592-.155A1.479 1.479 0 0 0 15 9.611v-.413c0-.099-.01-.197-.03-.294l-.335-1.68a.807.807 0 0 0-.43-.563 1.807 1.807 0 0 1-.853-.904l-.792-1.848A1.5 1.5 0 0 0 11.18 3H4.82Z"/>'
        }
      }))
    }
  })
}
Vue.use(globalComponents);
Vue.use(globalDirectives);
Vue.use(VueLazyload);

// Set the base URL of the API
if(process.env.NODE_ENV === "development") ApiService.init(process.env.VUE_APP_DEV_API);
if(process.env.NODE_ENV === "production")  ApiService.init(process.env.VUE_APP_PROD_API);

Vue.config.productionTip = false;
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
